import React, { FC } from 'react';
import { Start, Stop } from './styles';

const Twitter: FC<SVGIconProps> = ({ linearGradient }) => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M59.8931 15.9998C57.8398 16.9332 55.6264 17.5465 53.3331 17.8398C55.6798 16.4265 57.4931 14.1865 58.3464 11.4932C56.1331 12.8265 53.6798 13.7598 51.0931 14.2932C48.9864 11.9998 46.0264 10.6665 42.6664 10.6665C36.3998 10.6665 31.2798 15.7865 31.2798 22.1065C31.2798 23.0132 31.3864 23.8932 31.5731 24.7198C22.0798 24.2398 13.6264 19.6798 7.99978 12.7732C7.01311 14.4532 6.45311 16.4265 6.45311 18.5065C6.45311 22.4798 8.45311 25.9998 11.5464 27.9998C9.65311 27.9998 7.89311 27.4665 6.34645 26.6665C6.34645 26.6665 6.34645 26.6665 6.34645 26.7465C6.34645 32.2932 10.2931 36.9332 15.5198 37.9732C14.5598 38.2398 13.5464 38.3732 12.5064 38.3732C11.7864 38.3732 11.0664 38.2932 10.3731 38.1598C11.8131 42.6665 15.9998 46.0265 21.0398 46.1065C17.1464 49.1998 12.2131 51.0132 6.82645 51.0132C5.91978 51.0132 5.01311 50.9598 4.10645 50.8532C9.17311 54.1065 15.1998 55.9998 21.6531 55.9998C42.6664 55.9998 54.2131 38.5598 54.2131 23.4398C54.2131 22.9332 54.2131 22.4532 54.1864 21.9465C56.4264 20.3465 58.3464 18.3198 59.8931 15.9998Z"
      fill="url(#paint0_linear_173_159)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_173_159"
        x1="31.9998"
        y1="10.6665"
        x2="40.7352"
        y2="112.646"
        gradientUnits="userSpaceOnUse"
      >
        <Start startColor={linearGradient?.startColor} />
        <Stop stopColor={linearGradient?.stopColor} offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

export default Twitter;
